
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.743 10.074L5.036 7.751a.9.9 0 10-1.45 1.065l2.407 3.278a.9.9 0 001.433.024l5.599-7.123a.9.9 0 00-1.415-1.113l-4.867 6.192z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    